module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "chapter7"
    }
  }), _vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Rebecca Nicholls was slim and blond and enjoyed the effect she had upon men, particularly upon those to whom she was clearly unavailable, as she was to this overconfident policeman who’d emphasized his rank and held the handshake too long and dressed like an upmarket car salesman. In other circumstances she might have amused herself with this encounter but this afternoon these most definitely weren’t the circumstances. Not that she was nervous. She could handle it. But she wished there hadn’t been the feeling of uncertainty. She wasn’t an uncertain person.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca allowed the open admiration of her legs when she crossed them, otherwise sitting demurely with her hands in her lap in the secretary’s side office, inwardly-steeling herself against looking in the direction of Lomax’s adjoining room. Plastic sheeting had been draped completely over the outsides of the vast windows, hiding everything, but she didn’t need any reminder of the scene inside that still needed the police release to be cleaned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hoped she didn’t break down, although there was a perfectly understandable reason if she did, having witnessed a murder and now being questioned about it for a second time. Like it was perfectly understandable for her to have shivered when she’d entered, so close to the unseen horror. They shouldn’t have done this here, in the building itself. If they had to do it at all it should have been somewhere outside, a police station even.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m sorry to trouble you again.’ Bentley, who prided himself on his adjustable interrogation technique, was sure he knew just how to handle this haughty bitch. Nice legs though, all the way up to her ass: good tits, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve already told your sergeant what I saw.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Inspector,’ corrected Bentley, nodding sideways to the other man. ‘Rodgers is an inspector, not a sergeant.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca sighed. ‘Inspector then.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m just filling in the gaps: trying to fit things together,’ said Bentley, the tone still apologetic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What is it you want to know?’ demanded Rebecca, impatiently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re very busy, of course?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course. But I want to help if I can. Although I don’t see how.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley appeared to study Rebecca’s initial statement, open before him. ‘You’ve been at Enco-Corps now for…?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ten years,’ Rebecca supplied, when the pause stretched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘… Quite so, ten years.’ Bentley smiled up. ‘You’re American?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I transferred from the New York office six years ago. I’ve already told your inspector this, as well.’ Bentley —"), _c('i', [_vm._v("Detective Superintendent")]), _vm._v(" Bentley —was thick, all mouth and trousers: it wasn’t going to be too difficult at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Indeed you have. Did you know Gerald Lomax in New York, before he came here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca hesitated. ‘Not before he transferred here to run the operation, no.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But you did know him?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We met during his home visits.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Home visits meaning when he went back to New York?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is this important?’ There was another sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley regarded her blank faced. ‘What, Ms Nicholls?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t see what relevance there might be upon his murder in how and when I met Gerald.’ She shouldn’t have made the challenge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gerald?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What?’ Smart-assed fucking car salesman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is that what you called him, Gerald? He was your boss.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca uncrossed her legs, knowing she was in control. ‘You ever been to America, "), _c('i', [_vm._v("Superintendent?")]), _vm._v("’ It was silly using his sort of emphasis on the rank but she couldn’t help it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Wonderful country.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But you haven’t noticed that in America people call each other by their given names?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley smiled, contentedly. ‘Slipped my mind. But hasn’t how and when you met Gerald any relevance, Miss Nicholls?’ She wouldn’t be haughty in bed: probably went like a steam train.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve told you, I can’t see any.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Everything is relevant in a murder investigation, Ms Nicholls.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca was disconcerted by the way the man kept stressing the ‘Ms’. ‘I would have hardly thought what happened here yesterday requires much investigation: we’ve all told you what we saw.’ She shivered again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Like I said, I’m just fitting the parts together.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca breathed out again, heavily. ‘I’ve worked for Enco-Corps for a total of ten years. Quite obviously I would meet Gerald Lomax during his trips to New York. He was a colleague.’ The bastard was groping: maybe guessing- maybe someone down below had an inclination —but that’s all there was. All there could have been. They were waiting for her to admit something and there was no way she was going to do that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gerald Lomax came to London nine years ago?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m not sure of the precise date.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re not?’ queried Bentley, appearing surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I told you I wasn’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley paused, looking down at the scattered papers on the desk in front of him. ‘Gerald Lomax was transferred from New York?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I believe so.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re not sure of that, either?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You worked for Enco-Corps for ten years and Gerald Lomax was only transferred nine years ago. Surely there was a year’s overlap in New York, when you would have worked together?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca smiled, stretching the indulgent pause as long as possible. Patiently, speaking slowly as if for someone who needed simple words to understand simple things, she said, ‘I joined Enco-Corps in their Paris office. I worked there for two years before going to New York. By which time Gerald Lomax had been moved here. I worked in New York for two years before coming to London. Does that fit your parts together?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley made an expansive gesture with spread-apart hands. ‘Perfectly. So you met first during his visits to New York?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s what I said.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A business colleague?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What else?’ Rebecca’s growing confidence dipped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There weren’t any social occasions?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugged. ‘There may have been situations in New York that could be described as social. Business receptions, things like that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘May have been? None that you can specifically remember?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What about Mrs Lomax?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What about her?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you know Mrs Lomax?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca gestured behind her, to the trading area below. ‘We worked on the floor together before she married Gerald.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So you knew her as a business colleague, like you knew Mr Lomax?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We were friends.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('i', [_vm._v("Were?")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Are. We don’t —haven’t —seen as much of each other since she had Emily and moved to the country.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re Emily’s godmother, aren’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who told you that?’ demanded the woman, actually turning to stare down at the working floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley made a vague gesture. ‘Someone said it, in one of the statements. You are, aren’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So you know Mrs Lomax very well?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I suppose so, yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You sound reluctant?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It depends upon what you mean by very well.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you mean by very well, Ms Nicholls?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Damn the ‘Ms’. Rebecca said, ‘We really haven’t seen as much of each other in the last couple of years… longer maybe… as we once did. That’s what I mean. That we’ve kind of drifted apart.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You were much closer when she worked here? When she lived in London?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Did you know of her affair with Gerald Lomax, when she worked here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s an impertinent question!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley smiled. ‘That’s what policeman do, Ms Nicholls. Ask impertinent questions. Did you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Because you were close friends? Or because in these working surroundings…’ Bentley gestured to the open-plan, all-glass working area. ‘… it’s difficult to hide anything?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘As a friend, first. Then it became pretty much common knowledge.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How did you feel about it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Feel about it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gerald Lomax was a married man.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It was their business, not mine.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You didn’t have any moral feeling?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I said it was their business!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why did Jennifer Lomax kill her husband?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca didn’t have to feign the surprise at the abrupt, hard demand. ‘I haven’t the slightest idea! How on earth should I know?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’d found out, hadn’t she? About you and Gerald?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca didn’t speak. From the warmth she knew she was colouring. ‘There was nothing to find out about Gerald and me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s difficult to hide anything in a place like this,’ reminded Bentley.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no proof. The bastards down below might have guessed but they didn’t know —she and Gerald had been far more discreet than he had been with Jennifer —so they didn’t know and no-one could prove anything. ‘I had no relationship with Gerald Lomax.’ Rebecca was pleased at the steadiness in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s a nice flat, isn’t it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gerald’s, here in London. A nice flat?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve only been there once. At a party for Emily. But yes, it is a nice flat.’ She shouldn’t have qualified the visit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘When would that have been?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It must be more than a year ago.’ What was he getting at? They’d always been discreet there, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not weeks ago? Or just days?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The security would have influenced Lomax’s choice, I suppose,’ said Bentley, conversationally. He loved questioning people who despised him: thought they were cleverer. ‘Very American.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca felt emptied by uncertainty. ‘I don’t understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re on the CCTV recording, Ms Nicholls. We’ve got you several times. It’s a long loop but it doesn’t go back years.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca Nicholls sat motionless, without expression, for several moments, before she began to sob. There were no tears.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Bentley and Rodgers afterwards agreed that it was always the same: once the dam broke you got washed away in the confessional flood water until in the end you had to say something positive to get them to stop telling you the sexual fetishes of their grandmother’s pet hamster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca Nicholls admitted the affair had begun a month before Emily had been born and gave dates and hotels where she and Gerald Lomax had travelled together on overseas business trips, in addition to her accompanying him on the three-times-a-year updating and assessment returns to New York.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But Jennifer never knew.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You want me to pull down those screens and tell me that again?’ demanded Bentley. He had what he wanted. He didn’t have to go around in circles any more. This was the part when she learned he wasn’t the dickhead she’d thought him to be but the hardest bastard she’d ever met and that he’d been playing with her —enjoying himself —all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Are you going to charge me with anything?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fucking a married man isn’t a crime. Not in this country at least.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What then?’ She showed no outrage at the dismissive obscenity. He’d won. She supposed it was a spoil of victory to humiliate her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Bring a proper prosecution against Jennifer Lomax.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She didn’t kill Gerry because of me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sure.’ It was going to be a good case after all. Fuckable woman, eternal triangle, jealousy, revenge, all the ingredients. Plus a bloody clever —convincing almost —load of bollocks about hearing voices telling Jennifer what to do. Bentley was conscious of Rodgers looking at his watch beside him. He gave an imperceptible nod in return.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gerry was going to tell her. Get a divorce.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Did he?’ pounced Rodgers, sharing the questioning now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No! He said he’d tell me before he did. But he didn’t say anything. So he hadn’t told her.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was wrong, reflected Bentley, to believe it was only men who had their brains between their legs. ‘So you tell me, Ms Nicholls, why you think Jennifer Lomax came in here yesterday and tried to turn her husband into hamburger?’ The Americanism for an American had come to him after he’d begun speaking and he was proud of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I wasn’t responsible for his death.’ Real tears began, at last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If it hadn’t been you it would have been someone else,’ said Rodgers. It was well past conclusion time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We loved each other. We were going to get married.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And live happily ever after?’ said Bentley.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes! Jennifer was a mistake. Like Jane had been a mistake.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jesus, thought Bentley. ‘It’s a bastard, the search for eternal happiness. Maybe he’s found it now.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s going to happen to me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’ll be called, as a witness.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I won’t testify.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t tell me what you are or are not going to do, Ms Nicholls,’ warned Bentley, savouring the attitude Rebecca had attempted towards him at the beginning. ‘If you try to be stupid you’ll be subpoenaed. And if you refuse in court you’ll be jailed for contempt, among all those tongue-licking dykes. And if you try to leave the country I’ll apply for an international arrest warrant, which won’t achieve much but it’ll guarantee your name and photograph all over every newspaper you can think of and everyone can make up their own mind whether you were responsible or not.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Bastard!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Believe it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll lose my job.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You probably will,’ agreed Rodgers. It had just gone past the floodgates time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley thought the same. ‘Thank you for your help.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t want to go back downstairs. Not this afternoon.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Go home then,’ said Bentley.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Isn’t there any other way?’ pleaded the woman, tentatively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not even on your back with your legs splayed, thought Bentley. ‘A man has been murdered, horribly. My only interest is in seeing that justice is done.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She has to know? Jennifer, I mean?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She already does, doesn’t she?’ Bentley pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I suppose so. Gerald should have told me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gerald should have done a lot of things he didn’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("‘And not done a lot of the things that he did,’ picked up Rodgers, as the door closed behind the girl. He stood, looking down critically at the other man. ‘What the hell were you trying to do to me, about seeing that justice is done!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They both laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley said, ‘Lomax must have had a dick like a donkey.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And used it like one,’ agreed Rodgers. ‘You took a hell of a chance about a security camera. We don’t even know if there is one.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She wouldn’t have known either. She was too arrogant.’ He grinned. ‘Just like one of those television films, wasn’t it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Lucky,’ insisted Rodgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But I was right about another woman, wasn’t I!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You took longer than an hour to prove it,’ argued Rodgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ceremoniously Bentley took a five-pound note from his wallet and handed it to the other man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You could have done it under the hour,’ said Rodgers, accepting the bet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I can’t stand superior cows like that: I enjoyed myself, bringing her down. That was worth five pounds. Can you imagine those legs locked around your neck?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rodgers offered the money back. ‘You were right, about the case itself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bentley took his money back. ‘Wrapped and parcelled. We’ve got the classic woman-scorned scenario.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s the voice in her head going to tell her now?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That she tried but lost,’ said Bentley. ‘It’s a fucking nuisance we’ve got to go through things properly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That was part of it, wasn’t it?’ realized Rodgers. ‘Refusing any statement until she had a solicitor.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Jennifer Lomax is a very cunning killer,’ judged Bentley. ‘We’ve got ourselves another good one here, Malcolm. It’ll run.’")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("For the second night in succession, Bert Feltham got a call at home from Humphrey Perry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Things look very different,’ announced Perry. ‘There was another woman. It looks as if Jennifer Lomax found out.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’s faking the voice in her head?’ It still inevitably had to be a guilty plea but it could turn out better. No-one liked insanity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Bentley wants to interview her tomorrow at the hospital. Your man’s got to be there with me, obviously.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What time?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ten.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There could be more mileage in this than we thought.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Isn’t that why I have your home number?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perry was being wise after the event but Feltham didn’t challenge him.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578e5868","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 99
// module chunks = 0